import { render, staticRenderFns } from "./PEAApprovalRolesAndUsers.vue?vue&type=template&id=1ee5b058&scoped=true"
import script from "./PEAApprovalRolesAndUsers.vue?vue&type=script&lang=js"
export * from "./PEAApprovalRolesAndUsers.vue?vue&type=script&lang=js"
import style0 from "./PEAApprovalRolesAndUsers.vue?vue&type=style&index=0&id=1ee5b058&prod&scoped=true&lang=css"
import style1 from "./PEAApprovalRolesAndUsers.vue?vue&type=style&index=1&id=1ee5b058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee5b058",
  null
  
)

export default component.exports